const initialState = {
  loaded: false,
  data: {
    enabled: Object.create(null),
  },
}

export default initialState
